var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-sm-12" }, [
      _c(
        "form",
        {
          attrs: {
            autocomplete: "off",
            method: "post",
            "data-vv-scope": "form",
          },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onBeforeSaveItem(_vm.fallback)
            },
          },
        },
        [
          _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col-sm-auto" }, [
              _c("h1", { staticClass: "content-title" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialSelect",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        disabled: _vm.readonlyFormItem,
                        id: "input-appId",
                        name: "appId",
                        label: "name",
                        filterable: true,
                        options: _vm.lists.apps,
                        reduce: (option) => option.name,
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("appId") },
                        ],
                        error: _vm.fnFirstError("appId"),
                      },
                      on: { input: _vm.onChangeAppID },
                      model: {
                        value: _vm.form.appId,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "appId",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.appId",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.configId}.model.appid`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.showLayout
              ? _c("div", { staticClass: "col-sm-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialSelect",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            id: "input-layout",
                            name: "layout",
                            label: "name",
                            filterable: true,
                            options: _vm.lists.layouts,
                            reduce: (option) => option.name,
                            inputClasses: [
                              { "is-invalid": _vm.fnHasError("layout") },
                            ],
                            error: _vm.fnFirstError("layout"),
                          },
                          model: {
                            value: _vm.form.layout,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "layout",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.layout",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t(`${_vm.configId}.model.layout`)) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showFormat
              ? _c("div", { staticClass: "col-sm-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "MaterialSelect",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            id: "input-format",
                            name: "format",
                            label: "name",
                            filterable: true,
                            options: _vm.lists.formats,
                            reduceObject: true,
                            inputClasses: [
                              { "is-invalid": _vm.fnHasError("format") },
                            ],
                            error: _vm.fnFirstError("format"),
                          },
                          model: {
                            value: _vm.form.format,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "format",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.format",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t(`${_vm.configId}.model.format`)) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-12" },
              [
                _c(
                  "MaterialInput",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: false, min: 3 },
                        expression: "{required: false, 'min':3}",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      readonly: _vm.readonlyFormItem,
                      disabled: _vm.readonlyFormItem,
                      type: "text",
                      id: "input-municipality",
                      name: "municipality",
                      inputClasses: [
                        { "is-invalid": _vm.fnHasError("municipality") },
                      ],
                      error: _vm.fnFirstError("municipality"),
                    },
                    model: {
                      value: _vm.form.municipality,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "municipality",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.municipality",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t(`${_vm.configId}.model.municipality`)) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {
                            required: _vm.form.cover_page_status == 1,
                            min: 3,
                          },
                          expression:
                            "{required: form.cover_page_status == 1, 'min':3}",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyFormItem,
                        disabled: _vm.readonlyFormItem,
                        type: "text",
                        id: "input-title",
                        name: "title",
                        inputClasses: [
                          { "is-invalid": _vm.fnHasError("title") },
                        ],
                        error: _vm.fnFirstError("title"),
                      },
                      model: {
                        value: _vm.form.title,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "title",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.title",
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t(`${_vm.configId}.model.title`)) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.globalDoc
            ? _c("div", { staticClass: "mt-3" }, [
                _c("h6", [
                  _vm._v(_vm._s(_vm.$t(`${_vm.configId}.global.title`))),
                ]),
                _vm._v(" "),
                _c("hr", { staticClass: "mt-2" }),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-3" },
                    [
                      _c(
                        "MaterialSelect",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            id: "input-global-status",
                            name: "global-status",
                            label: "name",
                            filterable: true,
                            options: _vm.lists.onoff,
                            reduce: (option) => option.code,
                            inputClasses: [
                              { "is-invalid": _vm.fnHasError("global-status") },
                            ],
                            error: _vm.fnFirstError("global-status"),
                            helpText: _vm.helpGlobal.status,
                          },
                          model: {
                            value: _vm.form.global_doc.status,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.global_doc,
                                "status",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.global_doc.status",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(`${_vm.configId}.global.model.status`)
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-3" },
                    [
                      _c(
                        "MaterialSelect",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            disabled: _vm.readonlyFormItem,
                            id: "input-global-cover_page",
                            name: "global-cover_page",
                            label: "name",
                            filterable: true,
                            options: _vm.lists.onoff,
                            reduce: (option) => option.code,
                            inputClasses: [
                              {
                                "is-invalid":
                                  _vm.fnHasError("global-cover_page"),
                              },
                            ],
                            error: _vm.fnFirstError("global-cover_page"),
                            helpText: _vm.helpGlobal.cover_page,
                          },
                          model: {
                            value: _vm.form.global_doc.cover_page,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.global_doc,
                                "cover_page",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.global_doc.cover_page",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(
                                  `${_vm.configId}.global.model.cover_page`
                                )
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-6" },
                    [
                      _c(
                        "MaterialInput",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "",
                              expression: "''",
                            },
                          ],
                          staticClass: "city-form-group city-bg",
                          attrs: {
                            readonly: _vm.readonlyFormItem,
                            disabled: _vm.readonlyFormItem,
                            type: "text",
                            id: "input-global-pagination",
                            name: "global-pagination",
                            inputClasses: [
                              {
                                "is-invalid":
                                  _vm.fnHasError("global-pagination"),
                              },
                            ],
                            error: _vm.fnFirstError("global-pagination"),
                            helpText: _vm.helpGlobal.pagination,
                          },
                          model: {
                            value: _vm.form.global_doc.pagination,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.global_doc,
                                "pagination",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.global_doc.pagination",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(
                                  `${_vm.configId}.global.model.pagination`
                                )
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._t(
            "report",
            function () {
              return [
                _vm.report
                  ? _c("ConfigReportGeneral", {
                      staticClass: "mt-3",
                      attrs: {
                        configId: _vm.configId,
                        disabled: _vm.readonlyFormItem,
                        reportLabel: _vm.reportLabel,
                        reportHelp: _vm.reportHelp,
                        vScope: "form",
                      },
                      model: {
                        value: _vm.form.report,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "report", $$v)
                        },
                        expression: "form.report",
                      },
                    })
                  : _vm._e(),
              ]
            },
            {
              form: _vm.form.report,
              readonlyFormItem: _vm.readonlyFormItem,
              onInput: _vm.onReportInput,
            }
          ),
          _vm._v(" "),
          _vm.showZoomToFeatures
            ? _c("div", { staticClass: "mt-3" }, [
                _c("h6", [
                  _vm._v(_vm._s(_vm.$t(`${_vm.configId}.zoom.title`))),
                ]),
                _vm._v(" "),
                _c("hr", { staticClass: "mt-2" }),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-4" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "MaterialSelect",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              disabled: _vm.readonlyFormItem,
                              id: "input-zoomtype",
                              name: "zoomtype",
                              label: "name",
                              filterable: true,
                              options: _vm.lists.zoomtype,
                              reduce: (option) => option.code,
                              inputClasses: [
                                { "is-invalid": _vm.fnHasError("zoomtype") },
                              ],
                              error: _vm.fnFirstError("zoomtype"),
                            },
                            model: {
                              value: _vm.form.zoom_to_features.zoomtype,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.zoom_to_features,
                                  "zoomtype",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.zoom_to_features.zoomtype",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(`${_vm.configId}.zoom.model.zoomtype`)
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-4" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "MaterialInput",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|integer",
                                expression: "'required|integer'",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              readonly: _vm.readonlyFormItem,
                              disabled: _vm.readonlyFormItem,
                              type: "number",
                              id: "input-minmargin",
                              name: "minmargin",
                              inputClasses: [
                                { "is-invalid": _vm.fnHasError("minmargin") },
                              ],
                              error: _vm.fnFirstError("minmargin"),
                            },
                            model: {
                              value: _vm.form.zoom_to_features.minmargin,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.zoom_to_features,
                                  "minmargin",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.zoom_to_features.minmargin",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(`${_vm.configId}.zoom.model.minmargin`)
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-4" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "MaterialInput",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|decimal:3",
                                expression: "'required|decimal:3'",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              readonly: _vm.readonlyFormItem,
                              disabled: _vm.readonlyFormItem,
                              type: "text",
                              id: "input-minscale",
                              name: "minscale",
                              inputClasses: [
                                { "is-invalid": _vm.fnHasError("minscale") },
                              ],
                              error: _vm.fnFirstError("minscale"),
                            },
                            model: {
                              value: _vm.form.zoom_to_features.minscale,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.zoom_to_features,
                                  "minscale",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.zoom_to_features.minscale",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(`${_vm.configId}.zoom.model.minscale`)
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.draw
            ? _c("ConfigDrawGeneral", {
                staticClass: "mt-3",
                attrs: {
                  configId: _vm.configId,
                  disabled: _vm.readonlyFormItem,
                  vScope: "form",
                },
                model: {
                  value: _vm.form.draw,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "draw", $$v)
                  },
                  expression: "form.draw",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._t(
            "featureable",
            function () {
              return [
                _vm.featureable
                  ? _c("ConfigFeatureableGeneral", {
                      staticClass: "mt-3",
                      attrs: {
                        configId: _vm.configId,
                        disabled: _vm.readonlyFormItem || !_vm.form.draw.status,
                        featureableHelp: _vm.featureableHelp,
                        vScope: "form",
                      },
                      model: {
                        value: _vm.form.featureable,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "featureable", $$v)
                        },
                        expression: "form.featureable",
                      },
                    })
                  : _vm._e(),
              ]
            },
            {
              form: _vm.form.featureable,
              readonlyFormItem: _vm.readonlyFormItem,
              onInput: _vm.onFeatureableInput,
            }
          ),
          _vm._v(" "),
          _vm._t(
            "upload",
            function () {
              return [
                _vm.upload
                  ? _c("ConfigUploadGeneral", {
                      staticClass: "mt-3",
                      attrs: {
                        configId: _vm.configId,
                        uploadHelp: _vm.uploadHelp,
                        disabled: _vm.readonlyFormItem,
                        vScope: "form",
                      },
                      model: {
                        value: _vm.form.upload,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "upload", $$v)
                        },
                        expression: "form.upload",
                      },
                    })
                  : _vm._e(),
              ]
            },
            {
              form: _vm.form.upload,
              readonlyFormItem: _vm.readonlyFormItem,
              onInput: _vm.onUploadInput,
            }
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-3" }, [
            _c("div", { staticClass: "col photos" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("h6", { staticClass: "font-weight-normal" }, [
                    _vm._v(_vm._s(_vm.$t(`${_vm.configId}.model.logo`))),
                  ]),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mt-2" }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-sm-12" }, [
                  _c(
                    "div",
                    { staticClass: "photo mb-3 mb-sm-4" },
                    [
                      _c("UploadSingleImage", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "",
                            expression: "''",
                          },
                        ],
                        attrs: {
                          noOverlay: true,
                          name: "logo_path",
                          disabled: _vm.readonlyFormItem,
                        },
                        model: {
                          value: _vm.form.logo_path,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "logo_path", $$v)
                          },
                          expression: "form.logo_path",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("buttons-footer", {
            attrs: {
              enableButtons: !_vm.readonlyFormItem,
              cancelTitle: _vm.cancelTitle,
              submitTitle: _vm.submitTitle,
              isDisabled: _vm.isDisabled,
              showCancelButton: !!_vm.fallback,
            },
            on: {
              save: function ($event) {
                return _vm.onBeforeSaveItem(_vm.fallback)
              },
              cancel: function ($event) {
                return _vm.handleBack(_vm.fallback, !!_vm.fallback)
              },
            },
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }